import React from "react";
import * as logger from "../../../shared/logger";

import MultiSelect from "../../form-inputs/custom/multi-select";

const options = [
    {
        value: "1",
        text: "One",
    },
    {
        value: "2",
        text: "Two",
    },
    {
        value: "3",
        text: "Three",
    },
];

const MultiSelectExamples = () => {
    const initValue = [{ value: "1", text: "One" }];

    const updateField = (name, value) => {
        logger.log("Example: ", name, value);
    };

    return (
        <div>
            <h3>Multi Select</h3>
            <MultiSelect name="numbersMultiSelect" label="Numbers" options={options} updateOnChange={updateField} value={initValue} />
            {/*<MultiSelect 

                name="compositeMultiSelect"
                label="Provider Async"
                provider="/picklists/CompositeWoodCertificationCodes"
                updateOnChange={updateField}
                value={initValue}
            />*/}
        </div>
    );
};

export default MultiSelectExamples;
